export const FETCH_DELETE_DOCUMENTS_REQUEST = 'FETCH_DELETE_DOCUMENTS_REQUEST'
export const FETCH_DELETE_DOCUMENTS_SUCCESS = 'FETCH_DELETE_DOCUMENTS_SUCCESS'
export const FETCH_DELETE_DOCUMENTS_FALUIRE = 'FETCH_DELETE_DOCUMENTS_FALUIRE'
